import React from 'react';
import PropTypes from 'prop-types';
import { default as _DatePicker } from 'react-datepicker';
import moment from 'moment';
import 'react-datepicker/dist/react-datepicker.css';
import ru from 'date-fns/locale/ru';

import MaskedInput from '../inputs/MaskedInput';
import './style.scss';

const getValue = (value, format) => value ? moment(value, format).toDate() : null;

/**
 * Принимает пропы:
 * value - строка или объект Date
 *
 */

export default class DatePicker extends React.Component {

	static propTypes = {
		value: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
		format: PropTypes.string,
		parseFormat: PropTypes.string,
		onChange: PropTypes.func,
		timeFormat: PropTypes.string,
		inline: PropTypes.bool,
		showTimeSelect: PropTypes.bool,
		placeholder: PropTypes.string,
	};

	static defaultProps = {
		format: 'DD.MM.YYYY HH:mm',
		// parseFormat: 'DD.MM.YYYY HH:mm',
		timeFormat: 'HH:mm',
		inline: false,
		showTimeSelect: false,
	};

	constructor(props) {
		super(props);
		const date = getValue(props.value, props.parseFormat);
		this.state = {
			inputValue: date ? moment(date).format(this.props.format) : '',
			date,
			value: props.value
		};
	}

	componentDidUpdate(prevProps) {
		// console.log('componentDidUpdate', this.state.value, this.props.value);
		if (prevProps.value !== this.props.value) {
			const date = getValue(this.props.value, this.props.parseFormat);
			this.setState({
				inputValue: date ? moment(date).format(this.props.format) : '',
				date,
				value: this.props.value
			});
		}
	}

	onPickDate = date => {
		if (date) {
			const inputValue = moment(date).format(this.props.format);
			this.setState({ inputValue, date });
			// console.log('onPickDate', inputValue, this.state);
			if (this.props.onChange) this.props.onChange(moment(date).format());
		}
	};

	handleChangeRaw = e => {
		console.log('handleChangeRaw', e.target.value);
		this.setState({ inputValue: e.target.value });
	};

	handleBlur = res => {
		// console.log('handleBlur', res);
		if (!res) return;
		// if (moment.isMoment(res)) return;
		const value = res.target.value.trim();
		// console.log('handleBlur', value);
		if (!value.length) {
			if (this.props.onChange) this.props.onChange(null);
			this.setState({
				inputValue: '',
				date: null,
			});
		}
		else {
			let date = moment(this.state.date);
			let m = moment(value, this.props.format);
			if (m.isValid()) {
				if (this.props.minTime && m.isBefore(moment(this.props.minTime))) {
					m = moment(this.props.minTime);
				}
				if (this.props.maxTime && m.isAfter(moment(this.props.maxTime))) {
					m = moment(this.props.maxTime);
				}
				date = m;
				const isSame = this.props.value ? date.isSame(moment(this.props.value)) : false;
				// if (isSame) console.log('same date', date.format());
				if (date && !isSame && this.props.onChange) this.props.onChange(date.format());
				this.setState({
					inputValue: date ? date.format(this.props.format) : '',
					date: date ? date.toDate() : null,
				});
			}
			else {
				console.log('invalid date!');
				this.setState({
					inputValue: date ? date.format(this.props.format) : '',
				});
			}
		}
		if (this.props.onBlur) this.props.onBlur(res);
	};

	onInputChange = e => {
		console.log('onInputChange', e.target.value);
		this.setState({ inputValue: e.target.value });
	};

	onInputBlur = e => {
		const date = moment(e.target.value);
		console.log('onInputBlur', date, e.target.value);
	};

	render() {
		const { value, format, parseFormat, timeFormat, onChange, inline, ...rest } = this.props;
		// console.log('render', value);

		// const _value = this.state.inputValue || '';
		// const selected = value ? getValue(value, parseFormat) : null;

		const input = <MaskedInput
			mask={this.props.showTimeSelect ? '39.19.9999 29:59' : '39.19.9999'}
			formatChars={{
				'1': '[0-1]',
				'2': '[0-2]',
				'3': '[0-3]',
				'5': '[0-5]',
				'9': '[0-9]',
			}}
			onChangeOverride={this.onInputChange}
			onBlur={this.onInputBlur}
		/>;

		return <div className="date-picker">
			{/*{JSON.stringify(selected)}: {_value}*/}
			<_DatePicker
				{...rest}
				value={this.state.inputValue || ''}
				selected={this.state.date}
				dateFormat={this.props.showTimeSelect ? 'dd.MM.yyyy HH:mm' : 'dd.MM.yyyy'}
				locale={ru}
				timeFormat={timeFormat}
				onChange={this.onPickDate}
				disabledKeyboardNavigation
				showTimeSelect={this.props.showTimeSelect}
				onChangeRaw={this.handleChangeRaw}
				customInput={input}
				placeholderText={this.props.placeholder}
				onBlur={this.handleBlur}
				inline={this.props.inline}
			/>
		</div>;
	}

}
